"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeachersTable = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../common");
const server_1 = require("../../../server");
const popup_1 = require("../../base/popup");
const ui_1 = require("../ui");
const react_redux_1 = require("react-redux");
const account_1 = require("../../base/account");
exports.TeachersTable = react_1.default.memo(({ isPopup = false, isModify, handlerUpdateTeacherItem, setTeacherItem, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const tenant_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserTenantId)(state));
    const countRef = (0, react_1.useRef)(10);
    const pageCountRef = (0, react_1.useRef)(10);
    const [searchOption, setSearchOption] = (0, react_1.useState)('');
    const [page, setPage] = (0, react_1.useState)(0);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    // 해당 클래스에 해당하는 사용자 가져오기
    const { data, refetch } = (0, server_1.useMemberInfo)({
        level: '01',
        offset: page * countRef.current,
        ...(searchOption ? { nickname_like: searchOption } : {}),
        limit: countRef.current,
        orderby: ['level ASC', 'id'],
        active: true,
        ...(tenant_id !== 'default' ? { tenant_id } : {}),
    });
    const refetchRef = (0, react_1.useRef)(refetch);
    refetchRef.current = refetch;
    // 렌더마다 throttle 인스턴스가 재생성되어 스로틀이 무효화되던 것 수정 — 단일 인스턴스 유지
    const refetchList = (0, react_1.useMemo)(() => (0, lodash_1.throttle)(() => refetchRef.current(), 1000), []);
    const { headTitleList, tableReadDataKeys } = (0, react_1.useMemo)(() => {
        const headTitleList = [
            // ...(isModify && !isPopup ? [{ title: 'delete', space: 0.5, maxWidth: 40 }] : []),
            { title: 'name', space: 2 },
            // { title: 'participant', space: 1 },
            // ...(isPopup ? [{ title: 'status', space: 1 }] : []),
        ];
        const tableReadDataKeys = [
            // ...(isModify && !isPopup ? [{ title: 'delete', space: 0.5, maxWidth: 40 }] : []),
            { title: 'nickname', space: 2 },
            // { title: 'level_name', space: 1 },
            // ...(isPopup ? [{ title: 'status', space: 1 }] : []),
        ];
        return { headTitleList, tableReadDataKeys };
    }, [isModify, isPopup]);
    (0, react_1.useEffect)(() => {
        setSearchOption('');
        setPage(0);
    }, [isModify]);
    react_1.default.useEffect(() => {
        setPage(0);
    }, [searchOption]);
    react_1.default.useEffect(() => {
        if (!isPopup)
            return;
        refetchList();
    }, [isPopup, searchOption, page]);
    react_1.default.useEffect(() => {
        if (data && isPopup) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else {
                if (items.length > 0) {
                    setTestData(items);
                    setTotalCount(total_count);
                    return;
                }
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data, isPopup, page]);
    const handlerMoreData = (0, react_1.useCallback)((newPage) => {
        setPage(newPage);
    }, []);
    const handleSearch = (0, react_1.useCallback)((searchValue) => {
        setSearchOption(searchValue);
        setPage(0);
    }, []);
    const openDialog = (0, react_1.useCallback)(() => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: exports.TeachersTable,
            componentProps: {
                isPopup: true,
                handlerUpdateTeacherItem: (teacherItem) => {
                    setTeacherItem(teacherItem);
                    setTestData([teacherItem]);
                    setTotalCount(1);
                    APP.eventManager.publish(popup_1.TOGGLE_POPUP);
                },
            },
            title: '참여자 추가',
            width: 800,
            isFit: true,
        });
    }, []);
    const renderParticipantCount = () => (react_1.default.createElement("p", { className: "title", style: { lineHeight: '45px' } }, "\uAC15\uC0AC"));
    const renderSearchBar = (0, react_1.useMemo)(() => react_1.default.createElement(ui_1.SearchInput, { defaultValue: searchOption, setSearchOption: handleSearch }), [searchOption, handleSearch]);
    const renderEmpty = (0, react_1.useMemo)(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uAC15\uC0AC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderTitle = (0, react_1.useMemo)(() => {
        if (isPopup) {
            return (react_1.default.createElement("div", { className: "table-title", style: { alignItems: 'flex-end' } },
                react_1.default.createElement("div", { className: "left-wrap", style: { gap: 0 } }, renderParticipantCount()),
                react_1.default.createElement("div", { className: "right-wrap" }, renderSearchBar)));
        }
        else {
            return (react_1.default.createElement("div", { className: "table-title" },
                react_1.default.createElement("div", { className: "left-wrap" }, renderParticipantCount()),
                react_1.default.createElement("div", { className: "right-wrap" },
                    react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-blue btn-xmd", text: "\uCD94\uAC00", onClick: openDialog }))));
        }
    }, [isPopup, renderParticipantCount, renderSearchBar, openDialog]);
    const renderItem = (0, react_1.useCallback)((item) => {
        if (!item)
            return null;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: `${headItem.title}-${idx}`, className: "table-item member-item", style: {
                flex: headItem.space,
                maxWidth: headItem.maxWidth,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, (() => {
            switch (headItem.title) {
                case 'nickname':
                    return (react_1.default.createElement("p", { className: "overText2" },
                        item[headItem.title],
                        " (",
                        item.identifier,
                        ")"));
                case 'level_name':
                    return (react_1.default.createElement("p", { className: "overText2" }, t(`common.${item[headItem.title]}`)));
                case 'status':
                    return (react_1.default.createElement("p", { className: "overText" }, item[headItem.title] === 'inactive'
                        ? t(`status.${item[headItem.title]}`)
                        : t(`status.active`)));
                default:
                    return react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]);
            }
        })())));
    }, [tableReadDataKeys, setTestData]);
    const renderTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(common_1.Table, { className: "table-admin", 
            // 팝업에서는 페이지네이션을 scroll-content 밖으로(목록 아래) 분리 — 행이
            // 페이지네이션 아래로 삐져나오던 레이아웃 오류 방지. 인라인(폼)은 기존대로 유지.
            isInnerPage: !isPopup, isInfinite: false, page: page, pagingCount: pageCountRef.current, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData, handlerSelectItem: handlerUpdateTeacherItem }));
    }, [
        isPopup,
        page,
        pageCountRef,
        testData,
        totalCount,
        headTitleList,
        renderTitle,
        renderItem,
        renderEmpty,
        handlerMoreData,
        handlerUpdateTeacherItem
    ]);
    if (isPopup) {
        return (react_1.default.createElement("div", { className: "admin-container admin-container-popup" },
            react_1.default.createElement("div", { className: "members-popup" },
                react_1.default.createElement("div", { className: "members-table-wrap" }, renderTable))));
    }
    else {
        return renderTable;
    }
});
